import { BASE_URL } from './../app.constants';
import { Branch } from './../models/Branch';
import { Injectable } from '@angular/core';
import { AppState } from '../models/app.state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/find';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { Product } from '../models/Product';
import { Filter, FilterType as type, GeoFilter, PriceFilter, FilterType } from '../models/Filter';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ICategoryState } from '../reducers/category.reducer';


@Injectable()
export class ProductService {

  constructor(private store: Store<AppState>,
    private http: HttpClient) {
  }

  public loadWindows(): Observable<Product[]> {
    return this.store.select(state => {
      let filteredWindows = state.windowsState.windows;
      // let filter = state.windowfilter;
      // filteredWindows = this.filterWindowss(filteredWindows, filter);
      state.filters.forEach((filter: Filter) => {
        if (filter.type === FilterType.SEARCH) {
          filteredWindows = this.filterWindowss(filteredWindows, filter.value.toString());
        }
      });
      return filteredWindows;
    });
  }

  public getProducts(): Observable<Product[]> {
    return this.store.select(state => {
      let filteredProducts = state.productsState.products;
      state.filters.forEach((filter: Filter) => {
        filteredProducts = this.filterProducts(filteredProducts, filter);
      });
      return filteredProducts;
    });
  }
  getLanguages(): Observable<any> {
    return this.store.select(state => {
      const lang = state.lang;
      return lang;
    });
  }
  getCategoriesFromBackend() {
    return this.http.get<any[]>(`${BASE_URL}/Branches/GetAllbranches`)
      .map((branches: any) =>
        branches.map(branch => branch.branches)
          .map(arr => {
            // let res: Branch[] = [];
            const res = {};
            arr.map(obj =>
              res[obj.language] = obj.name
              // res.push({ name: obj.name, lang: obj.language, type: obj.type_id })
            );
            return res;
          }));
  }


  private filterProducts(products: Product[], filter: Filter) {

    switch (filter.type) {
      case type.CATEGORY: {
        const branches$ = this.store.select('categoriesState');
        let branches = [];
        branches$.subscribe((categoryState: ICategoryState) => {
          branches = categoryState.categories.map((category) => category);
        });
        const br = branches.filter(t => t.de === filter.value ||
          t.en === filter.value || t.it === filter.value || t.fr === filter.value)[0];

        return products.filter(p => p.category === br.en || p.category === br.de || p.category === br.it || p.category === br.fr);

        // return products.filter(p => p.category === filter.value);
      }

      case type.TAG: {
        return products.filter(p => p.tags ? p.tags.includes(filter.value.toString()) : false);
      }

      case type.PRICE: {
        const filterValue: PriceFilter = <PriceFilter>filter.value;
        return products.filter(p => p.newPrice < filterValue.maxPrice + 1 && p.newPrice > filterValue.minPrice - 1);
      }

      case type.GEO: {
        return products.filter(p => {
          const filterValue: GeoFilter = <GeoFilter>filter.value;
          const radius = filterValue.radius; // km
          const EARTH_RADIUS = 6371;
          const userLocationLongitude = filterValue.longitude;
          const userLocationLatitude = filterValue.latitude;

          const radians = (degrees) => degrees * Math.PI / 180;

          const productLatitude = p.location.latitude;
          const productLongitude = p.location.longitude;

          const dLat = radians(productLatitude - userLocationLatitude);
          const dLon = radians(productLongitude - userLocationLongitude);
          const lat1 = radians(userLocationLatitude);
          const lat2 = radians(productLatitude);

          const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          const d = EARTH_RADIUS * c;

          return d <= radius;
        });
      }

      case type.SEARCH: {
        const searchValue = <string>filter.value;
        if (searchValue) {
          const words = searchValue.split(' ');
          words.forEach(w => {
            products = products.filter(p => {
              return JSON.stringify(p).toLowerCase().includes(w.toLowerCase());
            });
          });
          return products;
        }
      }
    }
  }

  private filterWindowss(products: Product[], filter: string) {
    const searchValue = <string>filter;
    if (searchValue) {
      const words = searchValue.split(' ');
      words.forEach(w => {
        products = products.filter(p => {
          return JSON.stringify(p).toLowerCase().includes(w.toLowerCase());
        });
      });
    }
    return products;

  }


  public getProdcutsFromBackend(): Observable<Product[]> {
    const headers = new HttpHeaders();
    headers.append('Accept-Encoding', 'gzip, deflate, br');

    return this.http.get<Product[]>(`${BASE_URL}/products`);
  }

  public getWindowsFromBackend(): Observable<Product[]> {
    return this.http.get<Product[]>(`${BASE_URL}/saleswindow`);
  }

  public getProductById(id: string): Observable<Product> {
    return this.store.select(store => {
      return store.productsState.products.find(p => p.id.toString() === id);
    });
  }

  public getWindowById(id: string): Observable<Product> {
    return this.store.select(store => {
      return store.windowsState.windows.find(p => p.id.toString() === id);
    });
  }

  addNewsletter(email: string) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', 'https://sales-info.it');
    headers = headers.append('Access-Control-Allow-Methods', 'POST, GET');
    headers = headers.append('Access-Control-Allow-Headers', 'Content-Type');
    return this.http.post(`${BASE_URL}/newsletter/PostNewsLetter`, `"${email}"`, { headers: headers });
  }

  sendEmail(data: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', 'https://sales-info.it');
    headers = headers.append('Access-Control-Allow-Methods', 'POST, GET');
    headers = headers.append('Access-Control-Allow-Headers', 'Content-Type');
    return this.http.post(`${BASE_URL}/newsletter/ContactUsEmail`, data, { headers: headers });

  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/shared/product.service.ts